import { retryImport } from "@/shared";
import ErrorBoundary from "@components/error-boundary";
import { lazy, Suspense } from "react";
import { DIALOG_ID } from "../constants";

const Content = lazy(() => retryImport(() => import("./content")));

const ComparePlansDialog = () => {
	return (
		<ErrorBoundary
			feature="Compare plans"
			skipFallback
			toast="Failed to load compare plans. Please try again later."
		>
			<Suspense>
				<Content />
			</Suspense>
		</ErrorBoundary>
	);
};

ComparePlansDialog.id = DIALOG_ID;
ComparePlansDialog.overlayClassName = "!tw-bg-white";

export default ComparePlansDialog;
